<!-- Toolbar only shown when authenticated -->

<div [class.dark-theme]="isDarkMode">
  @if (isAuthenticated$ | async) {
    <mat-toolbar>
      <mat-toolbar-row>
        <span>
          <img
            src="assets/logo-wcg.svg"
            height="26"
            style="vertical-align: bottom"
          />
        </span>
        <mat-label class="mainLogo">eReviewer Migration Manager</mat-label>
        <span class="menu-spacer"></span>
        <a
          routerLink="/company-migration"
          mat-flat-button
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Company migration</a
        >
        <a
          routerLink="/queued-migrations"
          mat-flat-button
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Queued Migrations</a
        >
        <a
          routerLink="/migrations"
          mat-flat-button
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Migration tracker</a
        >
        <a
          routerLink="/metrics-tracker"
          mat-flat-button
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Fallout Report</a
        >
        <a
          routerLink="/statistics"
          mat-flat-button
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          >Statistics</a
        >
        <button
          mat-icon-button
          [matMenuTriggerFor]="menuuser"
          class="user_button"
        >
          @if (!(userPhotoUrl$ | async)) {
            <mat-icon>account_circle</mat-icon>
          }
          @if (userPhotoUrl$ | async; as userPhotoUrl) {
            <img
              [src]="userPhotoUrl"
              alt="Profile Photo"
              width="40"
              height="40"
              style="border-radius: 50%"
            />
          }
        </button>

        <mat-menu #menuuser="matMenu">
          <button mat-menu-item disabled>
            <mat-icon>person</mat-icon>
            <span style="color: black !important">{{
              (username$ | async) || "User"
            }}</span>
          </button>

          <button mat-menu-item (click)="logout()">
            <mat-icon>power_settings_new</mat-icon>
            <span>Sign Out</span>
          </button>
          <span class="placeholder">{{
            getPlaceHolderValue(PlaceHolderName.ERM_VERSION)
          }}</span>
          <span class="placeholder">{{
            getPlaceHolderValue(PlaceHolderName.DM_VERSION)
          }}</span>
        </mat-menu>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="loader-container">
      @if (store.isLoading()) {
        <mat-progress-bar
          mode="query"
          class="gradient-progress-bar"
        ></mat-progress-bar>
      }
    </div>
  }

  <router-outlet></router-outlet>
</div>
